import React, {useEffect, useState} from "react";
import {Col, Row, Button, Spinner} from "react-bootstrap";
import EditableTable from "../../../../primer/Editable-Table";
import {toast} from 'react-toastify';
import axios from 'axios'
import {useTranslation} from "../../../../../hooks/useTranslation";

const VisitContactPoints = ({clientData, setClientData}) => {
    const {t} = useTranslation();
    const [incrKey, setIncrKey] = useState(0);
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        setIncrKey(incrKey + 1);
    }, [clientData?.contactPoints])

    const clientContactPointsColumns = [
        {
            name: t('ClientsGeneralEdit.table.contactName'),
            field: "name",
            editable: true,
            inputType: {
                type: 'text',
            },
        },
        {
            name: t('ClientsGeneralEdit.table.mobilePhone'),
            field: "mobile",
            editable: true,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('ClientsGeneralEdit.table.landLine'),
            field: "landline",
            editable: true,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('ClientsGeneralEdit.table.otherPhone'),
            field: "otherPhone",
            editable: true,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('ClientsGeneralEdit.table.email'),
            field: "email",
            editable: true,
            inputType: {
                type: 'text',
            }
        },
        // {
        //     name: t('ClientsGeneralEdit.table.contactNotes'),
        //     field: "contactNotes",
        //     editable: false,
        //     inputType: {
        //         type: 'text',
        //     }
        // },
    ]

    const newContactPoint = {
        contactNotes: "",
        email: "",
        id: "",
        landline: "",
        mobile: "",
        name: "",
        no: "",
        otherPhone: ""
    }

    const contactPointActions = {
        insert: (e, data) => {
            newContactPoint[data.field] = data.value;
            if (data.value !== '') {
                let oldContactPoints = clientData.contactPoints;
                newContactPoint.no = oldContactPoints.length + 1;
                newContactPoint.id = oldContactPoints.length + 1;
                setClientData({
                    ...clientData,
                    contactPoints: [...oldContactPoints, newContactPoint],
                });
            }
        },
        update: (data, id) => {
            let contactPoints = clientData.contactPoints.slice();
            if (contactPoints.find(item => item.id === id) !== undefined) {
                contactPoints[id - 1] = {...contactPoints[id - 1], ...data};
                if (areAllValuesEmpty(contactPoints[id - 1])) {
                    contactPoints.splice(id - 1, 1);
                    contactPoints = rebuildContactPointsTable(contactPoints);
                }
                setClientData({...clientData, contactPoints: contactPoints});
            }
        },
        selected: () => {},
        delete: () => {}
    }

    const handleSaveContactPoints = () => {
        setLoader(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/prescription/update-client-contact-points`, {
            clientData: clientData
        }, {
            headers: { 'Content-Type': 'application/json' },
        }).then((res) => {
            if (res.data.status === "200") {
                setLoader(false);
                toast.success("Η αποθήκευση έγινε επιτυχώς.");
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            setLoader(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const areAllValuesEmpty = (obj) => {
        const unusedKeys = ['_id', 'no', 'id']
        for (const key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                if (!unusedKeys.includes(key) && obj[key] !== "") {
                    return false;
                }
            }
        }
        return true;
    }

    const rebuildContactPointsTable = (contactPoints) => {
        const clone = structuredClone(contactPoints);
        return clone.map((el, index) => {
            el.id = String(index + 1);
            el.no = String(index + 1);
            return el;
        })
    }

    return (
        <React.Fragment>
            {clientData && clientData?.contactPoints?.length >= 0 && (
                <Row className={"mt-2"}>
                    <Col md={12}>
                        <div className="text-muted mb-1"><i>Στοιχεία Επαφών</i></div>
                        <EditableTable
                            tableName="Edit Client Contact Points"
                            key={"Edit Client Contact Points" + incrKey}
                            allowActions={false}
                            allowToggleColumns={false}
                            columns={clientContactPointsColumns}
                            data={clientData.contactPoints}
                            allowInsertRow={true}
                            onUpdate={contactPointActions}
                            enableNewRowCheckbox={true}
                            fixedFirstRow={true}
                        />
                    </Col>
                </Row>
            )}
            <Row className={"mb-2"}>
                <Col md={12}>
                    <Button size={"sm"} style={{float: "right"}} onClick={() => handleSaveContactPoints()} disabled={loader}>
                        Αποθήκευση Επαφών
                        {loader && <Spinner className={"ml-2"} animation="border" variant="dark"/>}
                    </Button>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default VisitContactPoints;
